import { useAccount, useReadContract } from 'wagmi';
import { erc20Abi } from 'viem';
import { useMemo } from 'react';
import { formatRewardsDisplay } from '../utils/rewardsCalculator';

export function useTokenBalance(tokenAddress: `0x${string}`) {
  const { address } = useAccount();

  const { data, isLoading, error } = useReadContract({
    address: tokenAddress,
    abi: erc20Abi,
    functionName: 'balanceOf',
    args: address ? [address] : undefined,
    query: {
      enabled: !!address && !!tokenAddress,
      refetchInterval: 60000, // Refresh every 60 seconds
    },
    // enabled: !!address && !!tokenAddress,
    // watch: true, // auto-refresh on new blocks
  });

  const formatted = useMemo(() => {
    if (typeof data === 'undefined' || data === null) return null;
    return formatRewardsDisplay(Number(data) / 1e18);
  }, [data]);

  return {
    balance: data,
    formatted,
    isLoading,
    error,
  };
}
